// extracted by mini-css-extract-plugin
module.exports = {"local__menu":"locale-menu_local__menu__6qS3J","inner":"locale-menu_inner__4zVQx","icon":"locale-menu_icon__OCW_n"};